module.exports = __webpack_public_path__ + "img/open-1.a4118015.png";